import { Helmet } from 'react-helmet-async';
import { SeoDataInt } from "../../domain/Seo/SeoInt";

// This function takes care about standard meta tags of our sites

export default function SetSeoMeta({ title, description, name, type }: SeoDataInt) {
  return (
    <Helmet>
      {/* Standard metadata tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      
      {/* Facebook tags */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      
      {/* Twitter tags */}
      <meta name="twitter:creator" content={name} />
      <meta name="twitter:card" content={type} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
}
